import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "../../store/state/app.state";
import { CoworkingStepperComponent } from "../coworking-stepper/coworking-stepper.component";
import { CoworkingInfoComponent } from "../coworking-info/coworking-info.component";
import { IStep } from "../../data-types/steps.interface";
import { EButtonType } from "../../data-types/button.enum";
import { CustomValidatorsService } from "../../services/custom-validators.service";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { FormGroup } from "@angular/forms";
import { CoworkingService } from "../../services/coworking.service";
import { Coworking } from "../../data-types/coworking.interface";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { showAlertAction } from "../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
import { CowingSecurityEncryptService } from "../../services/cowingSecurityEncrypt.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";

@Component({
  selector: "cowing-core-coworking-funnel",
  templateUrl: "./coworking-funnel.component.html",
  styleUrls: ["./coworking-funnel.component.scss"],
})
export class CoworkingFunnelComponent {
  constructor(
    private _store: Store<IAppState>,
    private formBuilder: FormBuilder,
    private router: Router,
    private translate: TranslateService,
    private customValidatorsService: CustomValidatorsService,
    private coworkingService: CoworkingService,
    private securityService: CowingSecurityEncryptService
  ) {}
  public EButtonType = EButtonType;
  public steps: Array<IStep> = [
    {
      stepNumber: 1,
      isActive: true,
      title: "coworking.steps.general",
    },
    {
      stepNumber: 2,
      isActive: false,
      title: "coworking.steps.spaces",
    },
    {
      stepNumber: 3,
      isActive: false,
      title: "coworking.steps.services",
    },
    {
      stepNumber: 4,
      isActive: false,
      title: "coworking.steps.bank-info",
    },
    {
      stepNumber: 5,
      isActive: false,
      title: "coworking.steps.confirm",
    },
  ];
  public registerForm = this.formBuilder.group({
    generalForm: this.formBuilder.group({
      company_name: new FormControl(null, [Validators.required]),
      business_name: new FormControl(null, [Validators.required]),
      tax_id: new FormControl(null, [Validators.required]),
      fiscal_address: new FormControl(null, [Validators.required]),
      city: new FormControl(null, [Validators.required]),
      country: new FormControl(null, [Validators.required]),
      province: new FormControl(null, [Validators.required]),
      latitude: new FormControl(null, [Validators.required]),
      longitude: new FormControl(null, [Validators.required]),
      is_business_group: new FormControl("No", []),
      business_group: new FormControl({ value: null, disabled: true }, []),
      description: new FormControl(null, [
        Validators.required,
        Validators.maxLength(300),
      ]),
      web: new FormControl(null, [Validators.required]),
      phone: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),

      schedule_open_1: new FormControl(null, [Validators.required]),
      schedule_open_2: new FormControl(null, [Validators.required]),
      schedule_open_3: new FormControl(null, [Validators.required]),
      schedule_open_4: new FormControl(null, [Validators.required]),
      schedule_open_5: new FormControl(null, [Validators.required]),
      schedule_open_6: new FormControl(null, [Validators.required]),
      schedule_open_7: new FormControl(null, [Validators.required]),
      schedule_close_1: new FormControl(null, [Validators.required]),
      schedule_close_2: new FormControl(null, [Validators.required]),
      schedule_close_3: new FormControl(null, [Validators.required]),
      schedule_close_4: new FormControl(null, [Validators.required]),
      schedule_close_5: new FormControl(null, [Validators.required]),
      schedule_close_6: new FormControl(null, [Validators.required]),
      schedule_close_7: new FormControl(null, [Validators.required]),
      video_1: new FormControl(null),
      photo_1: new FormControl(null, [Validators.required]),
      photo_2: new FormControl(null, [Validators.required]),
      photo_3: new FormControl(null, [Validators.required]),
      photo_4: new FormControl(null, [Validators.required]),
      photo_5: new FormControl(null, [Validators.required]),
    }),
    spacesForm: this.formBuilder.array([
      new FormGroup({
        imagePath: new FormControl(null, [Validators.required]),
        name: new FormControl(null, [Validators.required]),
        spaceCategory: new FormControl(null, [Validators.required]),
        capacity: new FormControl(null, [Validators.required]),
        quantity: new FormControl(null, [Validators.required]),
        price_hour: new FormControl(null, [Validators.required]),
        price_day: new FormControl(null, [Validators.required]),
        price_week: new FormControl(null, [Validators.required]),
        price_month: new FormControl(null, [Validators.required]),
      }),
    ]),
    servicesForm: this.formBuilder.array([]),
    paymentInfoForm: this.formBuilder.group({
      holderId: new FormControl(null, [Validators.required]),
      swift: new FormControl(null, [Validators.required]),
      IBAN: new FormControl(null, [
        Validators.required,
        this.customValidatorsService.validateIBAN,
      ]),
      bankAddress: new FormControl(null, [Validators.required]),
    }),
  });

  public formControl(controlname) {
    return this.registerForm.controls;
  }
  public async setNextStep(event) {
    // if (this.whatStepIsActive === 5) {

    // } else {
    if (this.whatStepIsActive === this.steps.length) {
      this.goBack();
    } else {
      let activeStep = this.whatStepIsActive + 1;
      this.setNewNextStep(activeStep);
    }
    // }
  }

  private formGeneralInfoData() {
    const form = this.registerForm.get("generalForm").value;
    let formattedForm: any = new Coworking(form);
    formattedForm.email = this.registerForm
      .get("generalForm")
      .get("email").value;
    formattedForm.hours = [
      {
        day: 0,
        end: form.schedule_close_1,
        start: form.schedule_open_1,
      },
      {
        day: 1,
        end: form.schedule_close_2,
        start: form.schedule_open_2,
      },
      {
        day: 2,
        end: form.schedule_close_3,
        start: form.schedule_open_3,
      },
      {
        day: 3,
        end: form.schedule_close_4,
        start: form.schedule_open_4,
      },
      {
        day: 4,
        end: form.schedule_close_5,
        start: form.schedule_open_5,
      },
      {
        day: 5,
        end: form.schedule_close_6,
        start: form.schedule_open_6,
      },
      {
        day: 6,
        end: form.schedule_close_7,
        start: form.schedule_open_7,
      },
    ];
    return formattedForm;
  }
  private formBankData() {
    let encryptedData: string = this.securityService.encrypt(
      JSON.stringify(this.registerForm.get("paymentInfoForm").value)
    );
    return encryptedData;
  }
  private formServices() {
    let selectedServices: Array<any> = [];
    let servicesFormArray: any = this.registerForm.get("servicesForm");
    servicesFormArray.controls.forEach((serviceGroup) => {
      for (const service in serviceGroup.controls) {
        let anyService: any = serviceGroup.controls[service];
        selectedServices.push({
          id: anyService.rawValue.id,
          value: anyService.value,
        });
      }
    });
    return selectedServices;
  }
  private formMedia() {
    let mediaFormData: FormData = new FormData();

    if (this.registerForm.get("generalForm").get("video_1").value !== null) {
      mediaFormData.append(
        "video_1",
        this.registerForm.get("generalForm").get("video_1").value
      );
    }
    mediaFormData.append(
      "photo_1",
      this.registerForm.get("generalForm").get("photo_1").value
    );
    mediaFormData.append(
      "photo_2",
      this.registerForm.get("generalForm").get("photo_2").value
    );
    mediaFormData.append(
      "photo_3",
      this.registerForm.get("generalForm").get("photo_3").value
    );
    mediaFormData.append(
      "photo_4",
      this.registerForm.get("generalForm").get("photo_4").value
    );
    mediaFormData.append(
      "photo_5",
      this.registerForm.get("generalForm").get("photo_5").value
    );
    return mediaFormData;
  }
  public setLocation(location) {
    this.registerForm.get("generalForm").get("latitude").setValue(location.lat);
    this.registerForm
      .get("generalForm")
      .get("longitude")
      .setValue(location.lng);
    this.registerForm.get("generalForm").get("city").setValue(location.city);
    this.registerForm
      .get("generalForm")
      .get("country")
      .setValue(location.country);
    this.registerForm
      .get("generalForm")
      .get("province")
      .setValue(location.province);
  }

  public setPreviousStep(event) {
    let activeStep = this.whatStepIsActive - 1;
    this.setNewNextStep(activeStep);
  }

  private setNewNextStep(newStep: number) {
    this.steps = this.steps
      .map((step: IStep) => {
        step.isActive = false;
        return step;
      })
      .map((step: IStep) => {
        if (step.stepNumber === newStep || step.stepNumber < newStep) {
          step.isActive = true;
        }
        return step;
      });
  }

  public goBack() {
    const token = LocalStorageService.instance.get(EStorageType.Token);
    token
      ? this.router.navigate(["coworking-home"])
      : this.router.navigate(["landing"]);
  }
  public async confirmForm() {
    this._store.dispatch(showLoadingAction({}));
    try {
      const token = LocalStorageService.instance.get(EStorageType.Token);
      let coworkingData;
      // send new coworking data
      if (token) {
        coworkingData = await this.coworkingService.createCoworking(
          this.formGeneralInfoData()
        );
      } else {
        coworkingData = await this.coworkingService.createFirstCoworking(
          this.formGeneralInfoData()
        );
      }

      // send new coworking media data
      const coworkingMediaData = await this.coworkingService.addMedias(
        this.formMedia(),
        coworkingData.id
      );

      // send data for every space
      for (let space of this.registerForm.get("spacesForm").value) {
        let newSpace = { ...space };
        newSpace.type_id = newSpace.spaceCategory.id;
        delete newSpace.spaceCategory;
        delete newSpace.imagePath;

        const spaceAdded = await this.coworkingService.addSpaces(
          newSpace,
          coworkingData.id
        );
        let spaceImageFormData = new FormData();
        spaceImageFormData.append("file", space.imagePath);
        const spaceImageAdded = await this.coworkingService.addSpaceImage(
          spaceImageFormData,
          spaceAdded.id
        );
      }

      // send data for every service
      const servicesAdded = await this.coworkingService.addServices(
        this.formServices(),
        coworkingData.id
      );

      // send security data
      const bankInfoResponse = await this.coworkingService.addBankInfo(
        this.formBankData(),
        coworkingData.id
      );
      if (token) {
        CoworkingService.instance.newCoworkingAdded.next(coworkingData.id);
      }
      this.router.navigate(["landing"]);
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message:
              e.status === 401
                ? this.translate.instant("general.expired")
                : e.data.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }
  get isInitStep() {
    return this.whatStepIsActive === 1 ? true : false;
  }
  get isLastStep() {
    return this.whatStepIsActive === this.steps.length ? true : false;
  }
  get whatStepIsActive() {
    let lastIndex = 0;
    this.steps.map((step, i) => {
      if (step.isActive) lastIndex = i;
    });
    return this.steps[lastIndex].stepNumber;
  }

  get whatFormIsActive() {
    const activeStep = this.whatStepIsActive;
    if (activeStep === 1) {
      return "generalForm";
    } else if (activeStep === 2) {
      return "spacesForm";
    } else if (activeStep === 3) {
      return "servicesForm";
    } else if (activeStep === 4) {
      return "paymentInfoForm";
    }
  }
  get isDisabledNextStep() {
    const formName = this.whatFormIsActive;
    if (this.registerForm.get(formName)) {
      return this.registerForm.get(formName).invalid;
    }
    return false;
  }
}
